import { render, staticRenderFns } from "./addcountUsdt.vue?vue&type=template&id=3cc20ac2&scoped=true&"
import script from "./addcountUsdt.vue?vue&type=script&lang=js&"
export * from "./addcountUsdt.vue?vue&type=script&lang=js&"
import style0 from "./addcountUsdt.vue?vue&type=style&index=0&id=3cc20ac2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc20ac2",
  null
  
)

export default component.exports